import { UploadProps } from 'antd';

export const useUploadProps = (): UploadProps => ({
  name: 'file',
  multiple: true,
  beforeUpload: () => {
    return false;
  },
});
